import React from "react";

function Home() {
    return (
        <div className="mx-auto bg-green-200">
            <header className="mx-auto bg-pink-200 flex flex-row">
                <p>Home2</p>
            </header>
        </div>
    )
}

export default Home;